import React, { useState } from 'react';
import {
  createMuiTheme,
  responsiveFontSizes,
  ThemeProvider,
} from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
// import useMediaQuery from '@material-ui/core/useMediaQuery';

import myTheme from './theme';
import DeckGLMap from './map/DeckGLMap';
import ProductSummary from './productSummary/ProductSummary';
import EventsSummary from './eventSummary/EventsSummary';
import FabMenu from './menu/FabMenu';
import DirectionsModal from './menu/DirectionsModal';
import ProductExplainer from './menu/ProductExplainer';
// TODO: delete carrier modal
// import CarrierModal from './menu/CarrierModal';

function App() {
  const [directionsOpen, setDirectionsOpen] = useState(true);
  const [showExplainer, setShowExplainer] = useState(false);
  const [markerMode, setMarkerMode] = useState(true);
  const [dateRange, setDateRange] = useState([1972, 2021]);
  const [eventProfiles, setEventProfiles] = useState([]);
  const [eventYears, setEventYears] = useState({ ts: [], h: [], mh: [] });
  const [chartData, setChartData] = useState({
    years: [],
    unlimited: [],
    single: [],
    zero: [],
  });
  const [highlightedPathIndex, setHighlightedPathIndex] = useState(-1);
  const [locationTitle, setLocationTitle] = useState(null);
  const [darkMode, setDarkMode] = useState(false);
  // TODO: remove carrier stuff
  // const [showCarrierUpload, setShowCarrierUpload] = useState(false);
  // const [carrierMarkers, setCarrierMarkers] = useState([]);

  // TODO: move all date range filtering to useEffect() in App component

  // let prefersDark = useMediaQuery('(prefers-color-scheme: dark)');

  const switchTheme = () => {
    setDarkMode(!darkMode);
  };

  let theme = React.useMemo(
    () =>
      createMuiTheme({
        ...myTheme,
        palette: {
          ...myTheme.palette,
          type: darkMode ? 'dark' : 'light',
        },
      }),
    [darkMode]
  );
  theme = responsiveFontSizes(theme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        hideIconVariant={false}
        // hideIconVariant={
        //   success: ,
        //   error: ,
        //   warning: ,
        //   info:
        // }

        // content={(key, message) => (
        //   <MyCustomChildren id={key} message={message} />
        // )}
      >
        <main
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            bottom: '0',
            left: '0',
          }}
        >
          <DirectionsModal open={directionsOpen} setOpen={setDirectionsOpen} />
          <FabMenu
            markerMode={markerMode}
            updateMarkerMode={setMarkerMode}
            switchTheme={switchTheme}
            setDirectionsOpen={setDirectionsOpen}
            setShowExplainer={setShowExplainer}
            // setShowCarrierUpload={setShowCarrierUpload}
          />
          <DeckGLMap
            markerMode={markerMode}
            updateMarkerMode={setMarkerMode}
            dateRange={dateRange}
            setEventProfiles={setEventProfiles}
            setEventYears={setEventYears}
            setChartData={setChartData}
            highlightedPathIndex={highlightedPathIndex}
            setHighlightedPathIndex={setHighlightedPathIndex}
            setLocationTitle={setLocationTitle}
            darkMode={darkMode}
            // carrierMarkers={carrierMarkers}
          />
          {chartData.years.length > 0 && (
            <EventsSummary
              eventProfiles={eventProfiles}
              eventYears={eventYears}
              dateRange={dateRange}
              setDateRange={setDateRange}
              highlightedPathIndex={highlightedPathIndex}
              setHighlightedPathIndex={setHighlightedPathIndex}
            />
          )}
          {chartData.years.length > 0 && (
            <ProductSummary
              chartData={chartData}
              dateRange={dateRange}
              locationTitle={locationTitle}
              markerMode={markerMode}
            />
          )}

          <ProductExplainer show={showExplainer} setShow={setShowExplainer} />
          {/* <CarrierModal
            show={showCarrierUpload}
            setShow={setShowCarrierUpload}
            setPortfolioMarkers={setCarrierMarkers}
          /> */}
        </main>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
